import { Initiative } from '@schema/initiative'
import { PhaseType } from '@schema/phase'
import {
  InitiativeCreationStep,
  initiativeCreationSteps,
} from '../blocks/workflow'
import { CreationGuide } from '../blocks/CreationGuide'
import { useInitiativeAutoSave } from '../blocks/useInitiativeAutoSave'
import Column from '@app/components/layout/Column'

import { InlineWidget, useCalendlyEventListener } from 'react-calendly'
import { useEffect, useState } from 'react'

export const CallScheduleStep = ({
  initiative,
  selectedPhaseType,
  completeStep,
}: {
  initiative: Partial<Initiative>
  selectedPhaseType: PhaseType
  completeStep: (step: InitiativeCreationStep) => void
  uncompleteStep: (step: InitiativeCreationStep) => void
}) => {
  const [callScheduled, setCallScheduled] = useState(
    initiative.isCalendlyScheduled,
  )
  const name = `${initiative.contactFirstName} ${initiative.contactLastName}`

  useInitiativeAutoSave(
    initiative.id,
    { isCalendlyScheduled: callScheduled },
    0,
  )

  useCalendlyEventListener({
    onEventScheduled: () => {
      completeStep(initiativeCreationSteps.callSchedule)
      setCallScheduled(true)
    },
  })

  useEffect(() => {
    if (initiative.isCalendlyScheduled) {
      completeStep(initiativeCreationSteps.callSchedule)
    }
  }, [initiative.isCalendlyScheduled, completeStep])

  return (
    <CreationGuide
      selectedPhaseType={selectedPhaseType}
      currentStep={initiativeCreationSteps.callSchedule}
    >
      <Column gap="2.5rem" alignItems="stetch">
        <InlineWidget
          url="https://calendly.com/bela-crowdbuilding/gesprek-met-crowdbuilding"
          styles={{ height: '900px' }}
          //utm={{ utmSource: 'facebook', utmCampaign: 'spring_sale' }}
          prefill={{
            name: name,
            email: initiative.contactEmail,
          }}
        />
      </Column>
    </CreationGuide>
  )
}
